module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-48.e6dbc789.png";